<template>
  <span class="badge badge-warning text-uppercase rounded-sm" :class="{ 'dark-text': small }">
    {{ small ? translate("SHARED.PREMIUM_BADGE").charAt(0) : translate("SHARED.PREMIUM_BADGE") }}
  </span>
</template>

<script>
import useTranslate from "@/core/composables/translate";

export default {
  name: "PremiumBadge",

  props: {
    small: {
      type: Boolean,
      default: false,
    },
  },

  setup() {
    const { translate } = useTranslate();
    return {
      translate,
    };
  },
};
</script>
